import { render, staticRenderFns } from "./EcommerceTransactions.vue?vue&type=template&id=a49dfa6a&scoped=true&"
import script from "./EcommerceTransactions.vue?vue&type=script&lang=js&"
export * from "./EcommerceTransactions.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceTransactions.vue?vue&type=style&index=0&id=a49dfa6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a49dfa6a",
  null
  
)

export default component.exports